import moment from "moment";
import axios from "axios";
import { calcolaPercentualeDiluizione } from "./diluizione_utils";
import { isNumeroValido, parseNumeroItaliano } from "./numero_utils";
export default {
  data() {
    return {
      dialog: false,
      // Valorizzato = modalità modifica di un evento esistente; null =
      // creazione di uno nuovo.
      id_evento: null,
      date: moment().format("YYYY-MM-DD"),
      dialog_data: false,
      lista_colture: [],
      lista_avversita: [],
      fitofarmaci_utiliz: [],
      qta_fitofarmaci: [],
      volume_acqua: null,
      prodotti_list: [],
      // Selezione posizione via mappa aziendale SVG (Serra). Il vecchio
      // selettore Zona (elenco piatto) è stato ritirato da questo form: i
      // dati storici restano intatti e ancora visibili in lista eventi, ma
      // i nuovi eventi si posizionano solo tramite la mappa.
      id_serre: [],
      colture_serre: [],
      tab_serra: 0,
      // Mappa { [id_serra]: bool } invece di array per posizione: colture_serre
      // si popola in modo asincrono (una fetch per serra) e l'ordine di arrivo
      // non è garantito coincidere con l'ordine di id_serre, quindi indicizzare
      // per id anziché per indice evita disallineamenti.
      check_all_serra: {},
      // Selezione da ripristinare al prossimo giro del watcher su id_serre
      // (che altrimenti azzera sempre prodotti_list): usato solo da
      // apri_modifica per precompilare senza che il watcher la cancelli.
      _prodotti_list_pending: null,
      fase_fenologica: 0,
      lista_fasi_fenologiche: [
        { cod: 0, text: "Trapianto" },
        { cod: 1, text: "Fase Vegetativa" },
        { cod: 2, text: "Pre-Fioritura" },
      ],
      loading_nuovo: false,
      note: "",
    };
  },
  watch: {
    id_serre: function () {
      // In modifica, apri_modifica valorizza _prodotti_list_pending prima di
      // assegnare id_serre: qui va ripristinato invece di azzerare sempre,
      // altrimenti la precompilazione delle colture trattate andrebbe persa.
      this.prodotti_list = this._prodotti_list_pending || [];
      this._prodotti_list_pending = null;
      this.check_all_serra = {};
      let array_filtro = this.colture_serre.filter((item) =>
        this.id_serre.includes(item.id)
      );
      this.colture_serre = array_filtro;
      this.id_serre.forEach((id_serra) => {
        this.ricerca_colture_serra(id_serra);
      });
    },
  },
  computed: {
    fitofarmaci() {
      return this.$store.getters.get_fitofarmaci;
    },
    volumi_acqua_disponibili() {
      return this.$store.getters.get_volumi_acqua;
    },
    avversita() {
      return this.$store.getters.get_avversita;
    },
    num_box_ok() {
      return (
        this.qta_fitofarmaci.length == this.fitofarmaci_utiliz.length &&
        this.qta_fitofarmaci.every((qta) => isNumeroValido(qta))
      );
    },
  },
  methods: {
    isNumeroValido(qta) {
      return isNumeroValido(qta);
    },
    diluizione(qta) {
      return calcolaPercentualeDiluizione(qta, this.volume_acqua);
    },
    // Azzera tutti i campi del form. Necessario perché il dialog resta
    // montato tra un'apertura e l'altra (<NuovoEvento ref="nuovo_evento">
    // in eventi_tab.vue non è mai distrutto): senza reset esplicito,
    // aprire "Modifica" e poi "Aggiungi Evento" lascerebbe i campi
    // dell'evento appena modificato.
    _reset() {
      this.id_evento = null;
      this.date = moment().format("YYYY-MM-DD");
      this.volume_acqua = null;
      this.fitofarmaci_utiliz = [];
      this.qta_fitofarmaci = [];
      this.lista_avversita = [];
      this.fase_fenologica = 0;
      this.note = "";
      this._prodotti_list_pending = null;
      this.prodotti_list = [];
      this.id_serre = [];
      this.colture_serre = [];
      this.check_all_serra = {};
      this.tab_serra = 0;
    },
    open() {
      this._reset();
      this.dialog = true;
      if (!this.$store.getters.get_volumi_acqua.length) {
        this.$store.dispatch("fetch_volumi_acqua");
      }
    },
    apri_modifica(evento) {
      this._reset();
      this.id_evento = evento.id;
      this.date = moment.unix(evento.ts).format("YYYY-MM-DD");
      this.volume_acqua = evento.volume_acqua;
      this.fitofarmaci_utiliz = evento.fitofarmaci.map((f) => f.id_fitofarmaco);
      this.qta_fitofarmaci = evento.fitofarmaci.map((f) => String(f.qta_impiegata));
      this.lista_avversita = [...evento.id_avversit];
      this.fase_fenologica = evento.fase_fenol;
      this.note = evento.note || "";
      // Consumato dal watcher su id_serre subito sotto (deve essere
      // valorizzato PRIMA di assegnare id_serre, non dopo).
      this._prodotti_list_pending = evento.colture_trattate.map((c) => ({
        id: c.id_coltura,
        lotto: c.lotto_coltura,
      }));
      this.id_serre = [...(evento.id_serre || [])];
      this.dialog = true;
      if (!this.$store.getters.get_volumi_acqua.length) {
        this.$store.dispatch("fetch_volumi_acqua");
      }
    },
    ricerca_colture_serra(id_serra) {
      if (this.colture_serre.some((serra) => serra.id == id_serra)) {
        return;
      }
      let url =
        process.env.VUE_APP_API_ROOT +
        "/admin/lotti/serra/" +
        id_serra +
        "/colture";
      if (this.id_evento) {
        // Modalità modifica: le colture originariamente selezionate
        // potrebbero nel frattempo essere state segnate esaurite o scadute
        // per tempo — devono comunque restare visibili/deselezionabili.
        url += "?includi_esauriti=1&includi_scadute=1";
      }
      let auth = this.$store.getters.get_credential;
      axios.get(url, { auth: auth }).then((res) => {
        // Il backend esclude già esaurite/scadute (vedi _coltura_scaduta),
        // salvo i due flag sopra in modifica.
        this.colture_serre.push({
          id: id_serra,
          colture: res.data,
        });
        // Precarica i Lotto (codice + fornitore), non ancora in cache: la
        // lista raggruppata li mostra appena arrivano (reattivo).
        [...new Set(res.data.map((item) => item.lotto))].forEach((id_lotto) => {
          this.$store.dispatch("get_lotto_by_id", id_lotto);
        });
      });
    },
    // Raggruppa le colture di una serra per prodotto: lo stesso prodotto può
    // avere più lotti/fornitori diversi posizionati insieme.
    gruppi_colture(coltura_serra) {
      const map = {};
      const order = [];
      for (const item of coltura_serra.colture) {
        const id = item.coltura.id_prodotto;
        if (!map[id]) {
          map[id] = { id_prodotto: id, items: [] };
          order.push(id);
        }
        map[id].items.push(item);
      }
      return order.map((id) => map[id]);
    },
    nome_coltura(id) {
      return this.$store.getters.get_prodotto_by_id(id).nome.split(" in ");
    },
    fitofarmaco(id) {
      return this.$store.getters.get_fitofarmaco_by_id(id);
    },
    nome_serra(id) {
      let serra = this.$store.getters.getSerraById(id);
      return serra ? serra.nome : id;
    },
    lotto(id) {
      let lotto = this.$store.getters.get_lotto_by_id(id);
      if (lotto) {
        return lotto;
      }
      this.$store.dispatch("get_lotto_by_id", id);
      return null;
    },
    fornitore(id_lotto) {
      let lotto = this.lotto(id_lotto);
      if (!lotto) return null;
      return this.$store.getters.get_fornitore_by_id(lotto.id_fornitore);
    },
    fornitore_logo(id_lotto) {
      let fornitore = this.fornitore(id_lotto);
      if (!fornitore) return null;
      return (
        process.env.VUE_APP_API_ROOT +
        "/fornitore/" +
        fornitore.id +
        "/avatar?t=" +
        fornitore.logo_md5
      );
    },
    avatar_img(id) {
      return process.env.VUE_APP_API_ROOT + "/avatar_img/" + id;
    },
    // v-tabs (su id_serre) e v-tabs-items devono restare allineati per
    // indice: colture_serre si popola in modo asincrono (una fetch per
    // serra) e l'ordine di arrivo delle risposte non è garantito coincidere
    // con l'ordine di selezione, quindi entrambi i v-for iterano su
    // id_serre e risolvono l'entry corrispondente per id, mai per indice.
    entry_serra(id_serra) {
      return this.colture_serre.find((c) => c.id === id_serra) || null;
    },
    count_colture(id_serra) {
      let entry = this.entry_serra(id_serra);
      return entry ? entry.colture.length : null;
    },
    toggle_all_serra(id_serra, valore) {
      this.$set(this.check_all_serra, id_serra, valore);
      let entry = this.colture_serre.find((c) => c.id === id_serra);
      if (!entry) return;
      if (valore) {
        entry.colture.forEach((coltura) => {
          let presente = this.prodotti_list.some(
            (prodotto) =>
              prodotto.id == coltura.coltura.id_prodotto &&
              prodotto.lotto == coltura.lotto
          );
          if (!presente) {
            this.prodotti_list.push({
              id: coltura.coltura.id_prodotto,
              lotto: coltura.lotto,
            });
          }
        });
      } else {
        entry.colture.forEach((coltura) => {
          let index = this.prodotti_list.findIndex(
            (prodotto) =>
              prodotto.id == coltura.coltura.id_prodotto &&
              prodotto.lotto == coltura.lotto
          );
          if (index > -1) {
            this.prodotti_list.splice(index, 1);
          }
        });
      }
    },
    toggle_item(payload) {
      let index = this.prodotti_list.findIndex(
        (item) => item.id == payload.id && item.lotto == payload.lotto
      );
      if (index < 0) {
        this.prodotti_list.push({
          id: payload.id,
          lotto: payload.lotto,
        });
      } else {
        this.prodotti_list.splice(index, 1);
      }
    },
    item_selected(payload) {
      return this.prodotti_list.some(
        (item) => item.id == payload.id && item.lotto == payload.lotto
      );
    },
    invia_evento() {
      let array_fito = this.fitofarmaci_utiliz.map((id_fito, index) => {
        return {
          id_fito: id_fito,
          qta: parseNumeroItaliano(this.qta_fitofarmaci[index]),
        };
      });
      const arrayUnione = [].concat(...this.prodotti_list);
      const chiaveComposta = (oggetto) => `${oggetto.id}_${oggetto.lotto}`;
      const arrayPulito = Array.from(
        new Set(arrayUnione.map(chiaveComposta))
      ).map((chiave) => {
        const [id, lotto] = chiave.split("_");
        return arrayUnione.find(
          (oggetto) => oggetto.id === id && oggetto.lotto === lotto
        );
      });
      let payload = {
        ts: moment(this.date).format("X"),
        fitofarmaci: array_fito,
        avversita: this.lista_avversita,
        // Il selettore Zona legacy è stato ritirato da questo form: i
        // nuovi eventi si posizionano solo tramite id_serre (mappa).
        zone: [],
        id_serre: this.id_serre,
        colture: arrayPulito,
        fase_fenologica: this.fase_fenologica,
        note: this.note,
        // Campo facoltativo: se lasciato vuoto Vuetify emette "" invece di
        // null, e un FloatField Mongo con stringa vuota fa fallire il
        // salvataggio ("could not convert string to float: ''").
        volume_acqua: isNumeroValido(this.volume_acqua)
          ? parseNumeroItaliano(this.volume_acqua)
          : null,
      };
      this.loading_nuovo = true;
      let azione = this.id_evento
        ? this.$store.dispatch("modifica_evento", {
            id_evento: this.id_evento,
            ...payload,
          })
        : this.$store.dispatch("salva_nuovo_evento", payload);
      azione.then(() => {
        this.loading_nuovo = false;
        this.dialog = false;
      });
    },
  },
};
